import { AxiosRestApplicationClient as GeoDataRestApplicationClient } from '@g2-shared/api-client/generated/geo-data-app';
import {
  getOnboardingServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

export const GEO_DATA_KEY = 'GEO_DATA';

// Country
export const FETCH_COUNTRIES = `${GEO_DATA_KEY}/FETCH_COUNTRIES`;
export const FETCH_ALL_COUNTRIES = `${GEO_DATA_KEY}/FETCH_ALL_COUNTRIES`;
export const FETCH_COUNTRY_BY_ID = `${GEO_DATA_KEY}/FETCH_COUNTRY_BY_ID`;

// Country
export const FETCH_PLACES = `${GEO_DATA_KEY}/FETCH_PLACES`;
export const FETCH_PLACE_BY_ID = `${GEO_DATA_KEY}/FETCH_PLACE_BY_ID`;
export const FETCH_PLACES_BY_COUNTRY_ID = `${GEO_DATA_KEY}/FETCH_PLACES_BY_COUNTRY_ID`;

export const geoDataApiDefaultConfig = {
  retry: undefined,
};

export const useGeoDataApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...geoDataApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getOnboardingServerErrorMessage(error));
      logError(error, 'Error while calling geo data api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const geoDataAxiosClient = new GeoDataRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
